import React from 'react';
import Modal from 'react-modal';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import ZeroStateModalBody from './ZeroStateModalBody';
import ZeroStateModalNewAccountBody from './ZeroStateModalNewAccountBody/index';


const ZeroStateModal = (props) => {
  const portalClassNames = classNames({ 'self-serve-zero-state-modal-portal': props.isOpen });
  const bodyContent = props.isNewAccountModal ? <ZeroStateModalNewAccountBody /> : <ZeroStateModalBody />;
  return (
    <Modal
      bodyContent={bodyContent}
      isOpen={props.isOpen}
      className="self-serve-zero-state-modal"
      overlayClassName="self-serve-zero-state-modal-overlay"
      portalClassName={portalClassNames}
    >
      {bodyContent}
    </Modal>
  );
};

ZeroStateModal.defaultProps = {
  isNewAccountModal: false,
};

ZeroStateModal.propTypes = {
  isNewAccountModal: PropTypes.bool,
  isOpen: PropTypes.bool.isRequired,
};

export default ZeroStateModal;



// WEBPACK FOOTER //
// ./src-react/SelfServeModals/ZeroStateModal/index.jsx